import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getPaymentsReportFilteredData } from "../services/paymentReportsServices";

export default function FilterModal({ onClose, data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // Filter Data
  const [filterCriteria, setFilterCriteria] = useState({
    PaymentMethod: "",
    Amount: ""
  });

  const handleFilterBusinessDays = (e) => {
    e.preventDefault();
    const filteredResult = data.filter((item) => {
      const { PaymentMethod , Amount} = filterCriteria;

      let filterPaymentMethod = true;
      let filterAmount= true;

      if (PaymentMethod) {
        filterPaymentMethod = item?.PaymentMethod?.toLowerCase().includes(PaymentMethod.toLowerCase());
      }
      if (Amount) {
        filterAmount = item?.Amount?.toLowerCase().includes(Amount.toLowerCase());
      }

      return (
        filterPaymentMethod &&
        filterAmount
      );

    });

    setFilteredData(filteredResult);
    onClose();
    dispatch(getPaymentsReportFilteredData(filteredResult));
  };

  return (
    <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.reports.business_reports.filter")}
        modalContent={
          <Box p={4}>
            <form onSubmit={handleFilterBusinessDays}>
              <Stack spacing={6}>
                <Input
                  label={t("pages.reports.reports_tables.payment_method")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.payment_method")}
                  name="PaymentMethod"
                  value={filterCriteria.PaymentMethod}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      PaymentMethod: e.target.value,
                    })
                  }
                />
                <Input
                  label={t("pages.reports.reports_tables.amount")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.amount")}
                  name="Amount"
                  value={filterCriteria.Amount}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      Amount: e.target.value,
                    })
                  }
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
  );
}
